import React, { createContext, useCallback, useState, useContext } from 'react';
import { Institution } from '../entities/Institution';
import {
  createInstitution,
  CreateInstitutionResponse,
  getInstitution,
  updateInstitution,
} from '../services/institution';

interface InstitutionContextData {
  institution?: Institution;
  cleanLocal(): void;
  saveLocal(institutionData: Institution): void;
  save(saveinstitutionData: Institution): Promise<CreateInstitutionResponse>;
  /** Edição (0.13): carrega o cadastro atual para preencher o formulário. */
  load(id: string): Promise<Institution>;
  /** Edição (0.13): grava. Antes disso o módulo era write-once no back. */
  update(id: string, institutionData: Institution): Promise<Institution>;
}

const InstitutionContext = createContext<InstitutionContextData>(
  {} as InstitutionContextData,
);

export const InstitutionProvider: React.FC = ({ children }) => {
  const [institution, setInstitution] = useState<Institution>();

  const cleanLocal = useCallback(() => {
    setInstitution(undefined);
  }, []);

  const saveLocal = useCallback((institutionData: Institution) => {
    setInstitution((state) => ({ ...state, ...institutionData }));
  }, []);

  const save = useCallback(async (institutionData: Institution) => {
    const response = await createInstitution(institutionData);

    return response;
  }, []);

  const load = useCallback(async (id: string) => {
    const response = await getInstitution(id);

    setInstitution(response);

    return response;
  }, []);

  const update = useCallback(
    async (id: string, institutionData: Institution) => {
      const response = await updateInstitution(id, institutionData);

      setInstitution(response);

      return response;
    },
    [],
  );

  return (
    <InstitutionContext.Provider
      value={{
        institution,
        cleanLocal,
        saveLocal,
        save,
        load,
        update,
      }}
    >
      {children}
    </InstitutionContext.Provider>
  );
};

export const useInstitution = (): InstitutionContextData => {
  const context = useContext(InstitutionContext);

  if (!context) {
    throw new Error('useInstitution must be used within a InstitutionProvider');
  }

  return context;
};
